module.exports = __webpack_public_path__ + "img/20240830072819986dq0 (1).bc37100b.jpg";